import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, { logout } from "store/auth/auth.slice";
import showErrorPopupReducer from "store/ui/errorPopupScreen/errorPopupScreen.slice";
import signUpScreenReducer from "store/ui/signUpScreen/signUpScreen.slice";
import subscriptionPlanReducer from "store/ui/subscriptionPlan/subscriptionPlan.slice";
import showThankYouReducer from "store/ui/thankYouScreen/thankYouScreen.slice";
import showDonationAmountReducer from "store/ui/donationAmountScreen/donationAmountScreen.slice";
import userTypeReducer from "store/ui/userType/userType.slice";
import userReducer from "store/user/user.slice";
import createEditEventReducer from "./event/createEditEvent.slice";
import eventMetricsReducer from "./event/eventMetrics.slice";
import profileEventsReducer from "./event/profileEvents.slice";
import recommendedEventDetailReducer from "./event/recommendedEventDetail.slice";
import recommendedEventsReducer from "./event/recommendedEvents.slice";
import eventListReducer from "./eventList/eventList.slice";
import feedReducer from "./feed/feed.slice";
import { idolReducer } from "./idol/idol.slice";

import donorsListReducer from "./ui/donorsList/donorsList.slice";

import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import attendingEventsReducer from "./attendingEvents/attendingEvents.slice";
import causesReducer from "./causes/causes.slice";
import recommendedUsersReducer from "./recommendedUsers/recommendedUsers.slice";
import { searchUsersReducer } from "./user/searchUsers.slice";
import userPostsReducer from "./userPosts/userPosts.slice";
import volunteersReducer from "./volunteers/volunteers.slice";
import eventDetailsReducer from "./eventDetails/eventDetails.slice";
import projectsReducer from "./projects";
import campaingsReducer from "./campaigns";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user"],
};

const appReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  eventMetrics: eventMetricsReducer,
  userType: userTypeReducer,
  signUpScreen: signUpScreenReducer,
  subscriptionPlan: subscriptionPlanReducer,
  showThankYou: showThankYouReducer,
  showDonationAmount: showDonationAmountReducer,
  error: showErrorPopupReducer,
  donorsList: donorsListReducer,
  profileEvents: profileEventsReducer,
  eventList: eventListReducer,
  eventDetails: eventDetailsReducer,
  recommendedEvents: recommendedEventsReducer,
  recommendedEventDetail: recommendedEventDetailReducer,
  createEditEvent: createEditEventReducer,
  projects: projectsReducer,
  campaigns: campaingsReducer,
  feed: feedReducer,
  searchUsers: searchUsersReducer,
  causes: causesReducer,
  recommendedUsers: recommendedUsersReducer,
  idol: idolReducer,
  attendingEvents: attendingEventsReducer,
  userPosts: userPostsReducer,
  volunteers: volunteersReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction
) => {
  if (action.type === logout.type) {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
